import { useDispatch, useSelector } from "react-redux";

import { Cards } from "../../components/cards";
import { FetchGalleries } from "../../redux/gallery";
import { Grid } from "../../components/section";
import styled from "styled-components";
import { useEffect } from "react";

export const Gallery = () => {
  const dispatch = useDispatch();
  const { loading, galleries } = useSelector((state) => state.gallery);

  useEffect(() => {
    dispatch(FetchGalleries());
  }, [dispatch]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Container col="3">
        {galleries &&
          galleries
            ?.filter((x, i) => x && i <= 5)
            ?.map((r) => {
              const name = r?.fileName?.split("~")[1]?.split(".")[0];
              return (
                <Cards
                  version="4"
                  key={r.id}
                  image={r?.media?.mediaFiles[0]?.url}
                  imageDescription={name}
                />
              );
            })}
      </Container>
    </div>
  );
};

export default Gallery;

const Container = styled(Grid)`
  gap: 0;

  img {
    height: 100px;
  }
`;
